import axios from 'axios';
import { DIAMOND_TYPES, ORDER_STATUSES } from '../constants/appConstants';
import { getOrderId } from './orderItemDisplay';

/** Whether staff can cancel this order item (not already canceled). */
export function isOrderItemCancellable(item) {
  if (!item) return false;
  return item.status !== ORDER_STATUSES.CANCELED;
}

/** Default return-to-inventory flag when opening cancel UI for one item. */
export function defaultReturnToInventoryForCancel(item) {
  return item?.type !== DIAMOND_TYPES.CUSTOM;
}

/**
 * Cancel a single order item (same API paths as client items / order detail).
 * @param {object} item
 * @param {{ returnToInventory?: boolean }} options
 */
export async function cancelOrderItem(item, { returnToInventory = false } = {}) {
  const groupId = getOrderId(item);
  if (!groupId) {
    await axios.patch(`/api/order-items/${item._id}/status`, {
      status: ORDER_STATUSES.CANCELED,
      returnToInventory,
    });
    return;
  }
  if (item.status === ORDER_STATUSES.APPROVED || item.status === ORDER_STATUSES.REQUESTED) {
    await axios.post(`/api/orders/${groupId}/items/${item._id}/cancel`, { returnToInventory });
    return;
  }
  await axios.patch(`/api/orders/${groupId}/items/${item._id}/status`, {
    status: ORDER_STATUSES.CANCELED,
    returnToInventory,
  });
}

/** Cancel many order items with one request. */
export async function cancelOrderItems(items) {
  const list = items || [];
  if (list.length === 0) return;
  if (list.length === 1) {
    await cancelOrderItem(list[0], {
      returnToInventory: list[0].returnToInventory !== false,
    });
    return;
  }
  await axios.post('/api/order-items/bulk-cancel', {
    items: list.map((item) => ({
      itemId: item._id,
      returnToInventory: item.returnToInventory !== false,
    })),
  });
}
